import React, { useState } from 'react';
import { BasePage, ReleaseToggle } from '@sm/webassets';

import CovidEndpage from '../CovidEndpage';
import Embedded from '../Embedded';
import EmbeddedNonBranded from '../EmbeddedNonBranded';
import NonBranded from '../NonBranded';
import RebrandEpForm from '../RebrandEpForm';
import RebrandEpFormIntl from '../RebrandEpFormIntl';
import RebrandExistingUser from '../RebrandExistingUser';
import Research from '../Research';

const EndpageTemplates = () => {
  const [templateSelected, setTemplateSelected] = useState(false);

  return (
    <>
      <ReleaseToggle toggleId="Embedded">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return <Embedded />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="EmbeddedNonBranded">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return <EmbeddedNonBranded />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="NonBranded">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return <NonBranded />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="Research">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return <Research />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="CovidEndpage">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <CovidEndpage />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandEpFormIntl">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandEpFormIntl />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandExistingUser">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandExistingUser />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandEpForm">
        {showToggle => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandEpForm />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <If condition={!templateSelected}>
        <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
          <RebrandEpForm />
        </BasePage>
      </If>
    </>
  );
};

export default EndpageTemplates;
